export const authIsChecked = state => {
  return state.auth.checked
}

export const isSignedIn = state => {
  return !!state.auth.userId
}
